// Tesisatçı Web Sitesi - Sector Configuration
// Referans mockup'a birebir hizalanmış içerik. WhatsApp only.

export const WA_NUMBER = "905326369115"; // 0532 636 91 15
export const WA_DISPLAY = "0532 636 91 15";
export const PRICE_TL = 13000;
export const ADDRESS = "İstanbul, Türkiye";

export const waLink = (message: string) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

const GENERIC = `Merhaba Dijital Mustafa, tesisatçılara özel 13.000 TL web sitesi paketi hakkında bilgi almak ve örnek çalışmalarınızı incelemek istiyorum.`;

export const waMessages = {
  header: GENERIC,
  hero: GENERIC,
  package: `Merhaba Dijital Mustafa, tesisatçılara özel 13.000 TL web sitesi paketini başlatmak istiyorum. Firma adım: ... Hizmet verdiğim şehir/ilçe: ...`,
  final: GENERIC,
  footer: GENERIC,
  sticky: GENERIC,
  portfolio: (name: string) =>
    `Merhaba Dijital Mustafa, ${name} çalışmasını beğendim. Tesisat firmam için buna benzer bir web sitesi istiyorum.`,
};

// Referans görselde 4 kart
export const portfolio = [
  {
    name: "Acil Tesisat",
    url: "https://www.acil-tesisat.com",
    displayUrl: "www.acil-tesisat.com",
    image: "/images/sectors/tesisatci/portfolio-1.webp",
    badge: "7/24 çağrı odaklı",
  },
  {
    name: "Beylikdüzü Tesisat",
    url: "https://www.beylikduzutesisat.com.tr",
    displayUrl: "www.beylikduzutesisat.com.tr",
    image: "/images/sectors/tesisatci/portfolio-2.webp",
    badge: "Yerel SEO odaklı",
  },
  {
    name: "Beylikdüzü Elektrikçi",
    url: "https://beylikduzuelektrikci.tr",
    displayUrl: "beylikduzuelektrikci.tr",
    image: "/images/sectors/tesisatci/portfolio-4.webp",
    badge: "Farklı sektör örneği",
  },
  {
    name: "Esenyurt Elektrikçi",
    url: "https://esenyurtelektrikcii.com",
    displayUrl: "esenyurtelektrikcii.com",
    image: "/images/sectors/tesisatci/portfolio-5.webp",
    badge: "Farklı sektör örneği",
  },
];

export const faqs = [
  {
    q: "Domain ve hosting dahil mi?",
    a: "Evet. 1 yıllık domain, hosting ve SSL sertifikası 13.000 TL paket fiyatına dahildir ve tamamı sizin adınıza kayıt edilir.",
  },
  {
    q: "Site gerçekten 24 saatte hazır mı?",
    a: "Firma bilgileri, logo ve fotoğraflar eksiksiz iletildiğinde hedefimiz 24 saat içinde siteyi kontrolünüze sunmaktır.",
  },
  {
    q: "Kaç sayfa hazırlanıyor?",
    a: "Paket 5 sayfadan oluşur: Ana Sayfa, Hakkımızda, Hizmetler, Çalışma Bölgeleri ve İletişim. İhtiyaca göre ek sayfa eklenebilir.",
  },
  {
    q: "Google reklamı verebilir miyim?",
    a: "Site Google reklamlarına uyumlu altyapıyla teslim edilir. Reklam kampanya yönetimi paket fiyatına dahil değildir; ayrı olarak konuşulabilir.",
  },
  {
    q: "SEO dahil mi?",
    a: "Temel teknik SEO (başlık, açıklama, hız, mobil uyum, sitemap, schema) 13.000 TL pakete dahildir. Sıralama ve müşteri garantisi verilmez.",
  },
  {
    q: "Sonradan değişiklik yapılabilir mi?",
    a: "Teslim sonrası 1 revizyon hakkınız vardır. Küçük metin/görsel güncellemeleri için WhatsApp'tan iletişime geçmeniz yeterli.",
  },
];

export const included = [
  "Mobil uyumlu özel tasarım",
  "Firmanıza özel içerik",
  "WhatsApp bağlantısı",
  "Google Ads uyumlu yapı",
  "Temel teknik SEO",
  "1 revizyon",
  "24 saatte hazırlık hedefi",
];

export const compareChecks = [
  "Firma adınız",
  "Hizmetleriniz",
  "Bölgeleriniz",
  "Renkleriniz",
];
